import { useParams } from "react-router-dom";
import { CreateUpdateForm } from "./CreateUpdateForm";
import { GET_ANNOUNCEMENT } from "./graphql";
import { skip } from "node:test";
import { useQuery } from "@apollo/client";
import { Announcement } from "../../__generated__/graphql";
import { LoadingOverlay } from "../../components/Loading";

export const CreateUpdateAnnouncement = () => {
  const { announcementId, editionId } = useParams();
  const { data, loading } = useQuery(GET_ANNOUNCEMENT, {
    skip: !announcementId,
    variables: {
      id: announcementId,
    },
  });

  if (!editionId || loading) return <LoadingOverlay loading={loading} />;

  return (
    <CreateUpdateForm announcement={data?.announcement as unknown as Announcement || undefined} editionId={editionId} />
  );
};
